export default __webpack_public_path__ + "9552e1788b6c121006a676bbc513a396.woff";